import { useState, useEffect } from 'react';

const TZ = 'America/Chicago';

function Clock() {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(interval);
  }, []);

  const time = now.toLocaleTimeString('en-US', {
    timeZone: TZ,
    hour: 'numeric',
    minute: '2-digit',
    second: '2-digit',
  });

  return (
    <section className="card clock-section">
      <div className="clock-time">{time}</div>
    </section>
  );
}

export default Clock;
